import { Pipe, PipeTransform } from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeScript,
  SafeStyle,
  SafeUrl,
} from '@angular/platform-browser';

/**
 * Marks a value as trusted for a binding Angular would otherwise sanitise.
 *
 * There is deliberately no 'html' type. Bind HTML with plain [innerHTML]: Angular's sanitiser
 * keeps the formatting the app writes (b, strong, em, br, p, lists, links, code, class) and drops
 * what runs code (scripts, on* attributes, javascript: URLs) and inline style attributes. A
 * bypass rendered names that users type (a page, a provider, an address) as live HTML in every
 * staff session that showed them.
 */
@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any, type: string): SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
